/* eslint-disable */

var sPage = window.location.pathname;

$(document).ready(function() {

    $('.people__layout_filter .alphabet-filter').fadeIn();


  if(sPage == "/people/" || sPage == "/ncc-projects/"){
	first_char = JSON.parse(first_char);

	$('.num').addClass('disabled');

	for (var i = 0; i < first_char.length; i++) {
		$('[data-filter="' + first_char[i] + '"]').removeClass('disabled');
	}
  }
  if(sPage == "/research/" || sPage == "/research/in-progress/" || sPage == "/research/completed/") {
  	first_char = JSON.parse(first_char_pi);

  	$('.tax-research_status .num').addClass('disabled');
	
  	for (var i = 0; i < first_char.length; i++) {
  	  $('[data-filter="' + first_char[i] + '"]').removeClass('disabled');
  	}
  }
  if(sPage == "/research-documents/") {
  	first_char = JSON.parse(first_char_pi);

  	$('.template-research-docs .num').addClass('disabled');
	
  	for (var i = 0; i < first_char.length; i++) {
  	  $('[data-filter="' + first_char[i] + '"]').removeClass('disabled');
  	}
  }
});

jQuery(document).ready(function() {

  var hash = document.location.hash;
  
  if(hash == "#researchCollapse") {
    $('#researchCollapse').collapse('show');
  }

});

$('#list').click(function() {
	$('#thumbnail').removeClass('active');
	$('#thumbnail rect').attr('style', "fill:#828282");
	$('#list rect').attr('style', "fill:#c8102e");
	$(this).addClass('active');
	$('.people__layout').removeClass('thumbnail');
	$('.people__layout').addClass('list');
});

$('#thumbnail').click(function() {
	$('#list').removeClass('active');
	$('#thumbnail rect').attr('style', "fill:#c8102e");
	$('#list rect').attr('style', "fill:#828282");
	$(this).addClass('active');
	$('.people__layout').removeClass('list');
	$('.people__layout').addClass('thumbnail');
});


// WEBPACK FOOTER //
// ./scripts/routes/people.js